import { useEffect, useState } from "react";
import withLoader from "../../../../components/layouts/WithLoader";
import ProductionOrderService from "../../../../services/Production/ProductionOrderService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../../../utils/UtilsFormule";
import uploadAndDownloadService from "../../../../services/uploadAndDownloadFile";
import DataTableAssemblyComponentsWorkOrder from "../productionOrder/pages/DataTableAssemblyComponentsWorkOrder";
import DataTableAssemblyComponentsDechetsWorkOrder from "../productionOrder/pages/DataTableAssemblyComponentsDechetsWorkOrder";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import update from "immutability-helper";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { TextField } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { Snackbar } from "@material-ui/core";

import { Alert } from "@material-ui/lab";

const DetailsOperationExecutionBySup = ({ startLoading, stopLoading }) => {
  const [workOrder, setWorkOrder] = useState(null);
  const [time, setTime] = useState({ minutes: 0, seconds: 0 });
  const [onStartOperation, setOnStartOperation] = useState(false);

  const [isActive, setIsActive] = useState(false);
  const [onAddPopupExecution, setOnAddPopupExecution] = useState(false);
  const [onFinishPopupExecution, setOnFinishPopupExecution] = useState(false);

  const [bom, setBom] = useState([]);
  const [dechets, setDechets] = useState([]);
  const [avancementBtn, setAvancementBtn] = useState(false);
  const [ChoosePointage, setChoosePointage] = useState("");
  const [userList, setUserList] = useState([]);
  const [societeLabel, setSocieteLabel] = useState([]);
  const [idEmploye, setIdEmploye] = useState();
  const [quantity, setQuantity] = useState();
  const [quantityProduct, setQuantityProduct] = useState();
  const animatedComponents = makeAnimated();
  const [selectedOption, setSelectedOption] = useState(null);
  const [quantityDemande, setQuantityDemande] = useState(0);
  const [quantityGenere, setQuantityGenere] = useState(0);
  const [listDechets, setListDechets] = useState([]);
  const [dechetId, setDechetId] = useState(null);
  const [dechetSelectPlaceHolder, setDechetSelectPlaceHolder] =
    useState("Choisir...");

  const [unity, setUnity] = useState();
  const [quantityEnStock, setQuantityEnStock] = useState();
  const [productTableData, setProductTableData] = useState([]);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [dateEnd, setDateEnd] = useState();
  const [dateBegin, setDateBegin] = useState();
  const [causePause, setCausePause] = useState(null);
  const [testQte, setTestQte] = useState(true);
  const [nbrProduct, setNbrProduct] = useState(0);

  const navigate = useNavigate();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value.concat(":59"));
  };

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value.concat(":59"));
  };
  const convertir = (data) => {
    if (Array.isArray(data)) {
      return data.map((user) => ({
        value: user.id,
        label: `${user.firstName.trim()} ${user.lastName.trim()}`, // Combine name and surname
      }));
    }
    return []; // Return an empty array if the data structure is invalid or not an array
  };
  useEffect(() => {
    startLoading();
    ProductionOrderService.getWorkOrderById(
      getCurrentUserId(),
      localStorage.getItem("idWorkOrder")
    )
      .then((response) => {
        console.log("getWorkOrderById", response.data.success);
        setWorkOrder(response.data.success);
        setBom(response.data.bom);
        setDechets(response.data.dechet);
        response.data.dechet &&
          response.data.dechet.map((element) => {
            setListDechets((oldArray) => [
              ...oldArray,
              {
                value: element.assemblyComponentDecheWorkOrder.id,
                label: element.assemblyComponentDecheWorkOrder.product.name,
                customElements: {
                  quantityDemande:
                    element.assemblyComponentDecheWorkOrder.quantityDemande,
                  quantityGenere:
                    element.assemblyComponentDecheWorkOrder.quantityConsomme,
                  unityCode:
                    element.assemblyComponentDecheWorkOrder.unitOfMeasure.code,
                  quantityEnStock: element.quantityInStock,
                },
              },
            ]);
          });
        response.data.bom &&
          response.data.bom.map((element) => {
            const demande =
              parseFloat(
                element?.assemblyComponentsWorkOrder?.quantityDemande
              ) || 0;
            const consomme =
              parseFloat(
                element?.assemblyComponentsWorkOrder?.quantityConsomme
              ) || 0;

            let test = demande - consomme;
            console.log("test", test);
            if (test > element.quantityInStock) {
              console.log("test here");

              setTestQte(false);
            }
          });

        ProductionOrderService.getCrewMembersByWorkStation(
          getCurrentUserId(),
          response.data.success.workstation.id
        )
          .then((result) => {
            if (result.data.success)
              setUserList(convertir(result.data.success));
          })
          .catch((e) => {
            alert("problème de connexion");
          });
      })
      .catch((e) => {
        alert("problème de connexion");
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  useEffect(() => {
    let interval = null;

    if (isActive) {
      interval = setInterval(() => {
        setTime((prevTime) => {
          const newSeconds = prevTime.seconds + 1;
          const newMinutes =
            newSeconds >= 60 ? prevTime.minutes + 1 : prevTime.minutes;

          return {
            minutes: newMinutes,
            seconds: newSeconds >= 60 ? 0 : newSeconds,
          };
        });
      }, 1000);
    } else if (!isActive && (time.minutes !== 0 || time.seconds !== 0)) {
      setOnAddPopupExecution(true);
      // clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isActive, time]);

  useEffect(() => {
    if (time.seconds >= 3600) {
      // 3600 seconds = 60 minutes
      // setOnAddPopupExecution(true);
      setAvancementBtn(true);
      setIsActive(false); // Stop the stopwatch
    }
  }, [time]);

  const testAvancement = () => {
    if (workOrder?.state === "PENDING") {
      return <span className="badge bg-danger">en attente</span>;
    } else if (workOrder?.state === "STARTED") {
      return <span className="badge bg-primary">en cours</span>;
    } else if (workOrder?.state === "FINISHED") {
      return <span className="badge bg-success">terminé</span>;
    }
  };
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((error) => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : "+error);
      });
  };

  const handleChangePayement = (e) => {
    let payement = e.target.value;
    setChoosePointage(payement);
  };
  const handleMultiSelectChange = (selectedOptions) => {
    setSocieteLabel(selectedOptions);
    setIdEmploye(selectedOptions.value);
  };
  const onChangeQuantity = (event) => {
    setQuantity(event.target.value);
  };

  const onChangeQuantityProduct = (event) => {
    setQuantityProduct(event.target.value);
  };
  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };
  const onChangeSelectedDechet = (selectedOptionn) => {
    setSelectedOption();
    setDechetId(selectedOptionn.value);
    setDechetSelectPlaceHolder(selectedOptionn.label);
    setQuantityDemande(selectedOptionn.customElements.quantityDemande);
    setQuantityGenere(selectedOptionn.customElements.quantityGenere);
    setUnity(selectedOptionn.customElements.unityCode);
    setQuantityEnStock(selectedOptionn.customElements.quantityEnStock);
  };
  const onAddProductToList = (event) => {
    let productRef = null;
    let exist = false;
    let indexInDataTable;
    try {
      productTableData.forEach((element, index) => {
        console.log("element", element);
        if (element.id === dechetId) {
          indexInDataTable = index;
          productRef = element.productRef;
          exist = true;
          console.log("productMapById indexInDataTable", indexInDataTable);
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      listDechets.forEach((element) => {
        if (element.value === dechetId) {
          productRef = element.label;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    if (dechetId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Sélectionnez un produit ");
    } else {
      if (!exist) {
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            id: dechetId,
            quantity: quantityProduct,
          },
        ]);
      } else if (exist) {
        let productUpdateValue = productTableData[indexInDataTable];
        productUpdateValue.quantity = quantityProduct;
        let modelData = update(productTableData, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });
        setOpenInfoAlert(true);
        setInfoAlertText(
          "Info : Vous avez actualisé la quantité produit :  " + productRef
        );
        setProductTableData(modelData);
      }
    }
  };
  const columnsWithDelete = [
    {
      dataField: "productRef",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
  ];
  function handleTableChange({ productTableData }) {
    return productTableData;
  }
  const addWork = () => {
    // setEndDate();

    setAvancementBtn(false);
    let finalProductValue = {
      id: workOrder.product.id,
      quantity: quantity,
    };
    let model = {
      idUser: getCurrentUserId(),
      idUserExecution: idEmploye,
      idWorkOrder: workOrder.id,
      nbrDechet: nbrProduct,
      finalProductValue: finalProductValue,
      dechetValues: productTableData,
      startDate: dateBegin,
      endDate: dateEnd,
      workOrderType: "WORK",
    };
    startLoading();

    ProductionOrderService.pointingWorkOrderBySupervisor(model)
      .then((response) => {
        if (response.data.success) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement du travail avec succées");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const addPause = () => {
    setAvancementBtn(false);
    let finalProductValue = {
      id: workOrder.product.id,
      quantity: "0",
    };
    let model = {
      idUser: getCurrentUserId(),
      idUserExecution: idEmploye,
      idWorkOrder: workOrder.id,
      finalProductValue: finalProductValue,
      dechetValues: productTableData,
      startDate: dateBegin,
      endDate: dateEnd,
      workOrderType: "PAUSE",
      causePause: causePause,
    };

    startLoading();
    ProductionOrderService.pointingWorkOrderBySupervisor(model)
      .then((response) => {
        if (response.data.success) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement de pause avec succées");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onChangeCausePauseHandler = (event) => {
    setCausePause(event.target.value);
  };
  const onChangeNbrProduct = (event) => {
    setNbrProduct(event.target.value);
  };
  const pointageChooseUI = () => {
    if (ChoosePointage === "WORK") {
      return (
        <section class="content">
          <div class="row">
            <div class="col-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">Pointage du travail</h3>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="inputName">
                          Produit : {workOrder.product.productCode}-
                          {workOrder.product.barcode}-{workOrder.product.name}
                        </label>
                        <br />
                        <label htmlFor="inputName">
                          Quantité demandée : {workOrder.quantity}{" "}
                          {workOrder.billOfMaterials.unitOfMeasure.code}
                        </label>
                        <br />
                        <label htmlFor="inputName">
                          Quantité Produite : {workOrder.quantityProduite}{" "}
                          {workOrder.billOfMaterials.unitOfMeasure.code}
                        </label>

                        <input
                          placeholder="Saisir la nouvelle quantité"
                          onChange={onChangeQuantity}
                          type="number"
                          min="0"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="inputName">Produit deffectué :</label>
                        <br />
                        <label htmlFor="inputName">
                          Quantité Dechet : {workOrder.quantityProduiteDechet}{" "}
                          {workOrder.billOfMaterials.unitOfMeasure.code}
                        </label>

                        <input
                          placeholder="Saisir la nouvelle quantité"
                          onChange={onChangeNbrProduct}
                          type="number"
                          min="0"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Choisir un employé:</label>
                        <Select
                          options={userList}
                          value={societeLabel}
                          onChange={handleMultiSelectChange}
                          closeMenuOnSelect={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-sm-6">
                      <label htmlFor="inputName">Les déchets</label>

                      <Select
                        styles={styles}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOption}
                        onChange={onChangeSelectedDechet}
                        options={listDechets}
                        placeholder={dechetSelectPlaceHolder}
                      />
                    </div>
                    <div className="form-group col-sm-6">
                      <label htmlFor="inputName">
                        quantité demandé : {quantityDemande}-quantité généré :{" "}
                        {quantityGenere} - quantité en stock : {quantityEnStock}{" "}
                        {unity}
                      </label>
                      <input
                        placeholder="Saisir la nouvelle quantité"
                        onChange={onChangeQuantityProduct}
                        type="number"
                        min="0"
                        id="inputName"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div className="col-sm-12  text-center">
                      <button
                        style={{ marginBottom: 20 }}
                        className="btn btn-dark"
                        onClick={onAddProductToList}
                      >
                        <i class="fas fa-plus"></i>
                        Liste des déchets{" "}
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        {productTableData && (
                          <ToolkitProvider
                            keyField="idProduct"
                            data={productTableData}
                            columns={columnsWithDelete}
                            onTableChange={handleTableChange}
                          >
                            {(props) => (
                              <div>
                                <div className="row">
                                  <BootstrapTable
                                    {...props.baseProps}
                                    striped
                                    hover
                                    condensed
                                  />
                                </div>
                              </div>
                            )}
                          </ToolkitProvider>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <button
                    type="button"
                    onClick={addWork}
                    class="btn btn-dark"
                    data-dismiss="modal"
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    } else if (ChoosePointage === "PAUSE") {
      return (
        <div class="row">
          <div class="col-md-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">Pointage du pause </h3>
              </div>
              <div className="card-body">
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label>Choisir un employé:</label>
                      <Select
                        options={userList}
                        value={societeLabel}
                        onChange={handleMultiSelectChange}
                        closeMenuOnSelect={true}
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label>Cause de pause:</label>
                      <input
                        value={causePause}
                        // required="required"
                        onChange={onChangeCausePauseHandler}
                        type="text"
                        id="causePause"
                        className="form-control"
                        placeholder="Saisir..."
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="inputName">Date début</label>

                      <TextField
                        style={{ width: "100%" }}
                        className="col-sm-12"
                        variant="outlined"
                        value={dateBegin}
                        onChange={onChangeDateBegin}
                        id="datetime-local"
                        type="datetime-local"
                        defaultValue="date"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        size="small"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="inputName">Date fin</label>

                      <TextField
                        style={{ width: "100%" }}
                        className="col-sm-12"
                        variant="outlined"
                        value={dateEnd}
                        onChange={onChangeDateEnd}
                        id="datetime-local"
                        type="datetime-local"
                        defaultValue="date"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        size="small"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button
                  type="button"
                  onClick={addPause}
                  class="btn btn-dark"
                  data-dismiss="modal"
                >
                  Confirmer
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <div className="row">
                <div className="col-sm-9">
                  <h3 className="card-title">L'ordre de production : </h3>
                  {workOrder?.productionOrder &&
                    workOrder?.productionOrder.code}
                  {workOrder?.productionOrder &&
                    workOrder?.productionOrder.name}
                </div>
                {workOrder?.productionOrder && (
                  <div className="col-sm-3">
                    Date limite :
                    {UtilsFormule.formatDateHours(
                      workOrder?.productionOrder?.scheduledDate
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="card-body">
              <label> Produit: </label> {workOrder?.product.productCode}-
              {workOrder?.product.barcode}-{workOrder?.product.name} <br />
              <label> Quantité à produire : </label> {workOrder?.quantity}
              <br />
              <label> Quantité produite : </label> {workOrder?.quantityProduite}
             
              <br />
              <label>
                Quantité Dechet : {workOrder?.quantityProduiteDechet}{" "}
                
              </label>
              <br />
              <label> les composants </label>
              {bom.length > 0 && (
                <DataTableAssemblyComponentsWorkOrder listComponents={bom} />
              )}
              <br />
              <label>Les déchets</label>
              <DataTableAssemblyComponentsDechetsWorkOrder
                listComponents={dechets}
              />
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="row">
                <div className="col-sm-6">
                  <h3 className="card-title">
                    Operation : {workOrder?.operationDetails.operation.code}-
                    {workOrder?.operationDetails.operation.name}
                  </h3>{" "}
                </div>
                <div className="col-sm-3"> </div>
                <div className="col-sm-3">
                  Date limite :
                  {UtilsFormule.formatDateHours(workOrder?.scheduledDate)}
                </div>
              </div>
            </div>{" "}
            <div className="card-body">
              <label>Station de travail :</label> {workOrder?.workstation.code}-{" "}
              {workOrder?.workstation.name}
              <br />
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Operation</th>
                    <th>SETUP TIME (s)</th>
                    <th>transfert TIME (s)</th>
                    <th>Avancement</th>
                    <th>Guide</th>
                  </tr>
                </thead>
                <tbody>
                  {workOrder?.operationDetails && (
                    <tr>
                      <td>
                        {workOrder?.operationDetails.operation.code}-
                        {workOrder?.operationDetails.operation.name}
                      </td>
                      <td>{workOrder?.operationDetails.setupTime}</td>
                      <td>{workOrder?.operationDetails.transferTime}</td>

                      <td>{testAvancement()}</td>
                      <td>
                        <button
                          style={{ width: 40 }}
                          class="btn bg-gray btn-sm "
                          disabled={
                            workOrder?.operationDetails.operation.path === "any"
                          }
                          onClick={() =>
                            onShowFileInOtherWizndowHandler(
                              workOrder?.operationDetails.operation.path
                            )
                          }
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {workOrder?.state !== "FINISHED" && testQte && (
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-sm-6">
                    <h3 className="card-title">Execution:</h3>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <h5 className="card-title">Pointage de l'opération</h5>
                <div class="row">
                  <div class="col-2"></div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      onChange={(e) => handleChangePayement(e)}
                    >
                      <option key={0} value={0}>
                        Pointage{" "}
                      </option>
                      <option key={1} value={"WORK"}>
                        Pointage du travail
                      </option>
                      <option key={2} value={"PAUSE"}>
                        Pointage du pause
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          )}
          {testQte === false && (
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  Certains produits ne sont pas en stock
                </h5>
              </div>
            </div>
          )}

          {pointageChooseUI()}
        </div>
      </section>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(DetailsOperationExecutionBySup);
